// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___vGHP","field":"styles_field__3HWqp","fieldCol":"styles_fieldCol__3n6Ag","diffCol":"styles_diffCol__3DkX0","diff":"styles_diff__3TMte"};